import React from "react";
import { CardContent, Typography, Stack, Box, Avatar } from "@mui/material";
import EventBusy from "../../assets/images/event_busy.png";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";

function TotalWorkRequest({ response }) {
  const navigate=useNavigate()
  return (
    <>
      <StyledCard sx={{ cursor: "pointer" }}>
        <CardContent onClick={() => navigate("/departmentworkrequest") }>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box>
              <Typography mb={1.5} variant="h5" color={"text.primary"}>
                Total Work Request
              </Typography>
              <Typography m={0} variant="h1" color={"#435954"}>
                {response?.totalWorkRequestCount}
              </Typography>
            </Box>
            <Box bgcolor={"#435954"} p={1} borderRadius={50}>
              <Avatar
                alt="Remy Sharp"
                src={EventBusy}
                sx={{ width: 24, height: 24 }}
              ></Avatar>
            </Box>
          </Stack>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default TotalWorkRequest;
